export default __webpack_public_path__ + "static/media/boy1.f8b76f17.png";